import { SESSION_STORAGE_KEYS } from '@constants/constants';
import { SessionStorage } from '@utils/storage';
import { DEEP_LINK_CONFIG, DeepLinkConfig, SUBMODULE_QUERY_PARAM } from '../constants';
import { isDeepLinkSubmodule } from './getDeepLinkSubmodule';
import clearDeepLinkStorage from './clearDeepLinkStorage';

/**
 * Stores the submodule and its params from the /redirect query string. Params are all-or-nothing:
 * if any is missing or invalid, only the submodule is stored. Returns the query params left over
 * (e.g. utm_source) so they can be passed on.
 */
const storeDeepLink = (searchParams: URLSearchParams): URLSearchParams => {
  clearDeepLinkStorage();

  const remainingParams = new URLSearchParams(searchParams);
  const submodule = searchParams.get(SUBMODULE_QUERY_PARAM);
  remainingParams.delete(SUBMODULE_QUERY_PARAM);

  if (!isDeepLinkSubmodule(submodule)) return remainingParams;

  const { params } = DEEP_LINK_CONFIG[submodule] as DeepLinkConfig;
  params.forEach(({ query }) => remainingParams.delete(query));

  SessionStorage.setItem(SESSION_STORAGE_KEYS.SUBMODULE_TO_REDIRECT, submodule);

  const values = params.map(({ query }) => searchParams.get(query) ?? '');
  const areParamsValid = params.every(({ isValid }, index) => isValid(values[index]));
  if (areParamsValid) {
    params.forEach(({ storageKey }, index) => SessionStorage.setItem(storageKey, values[index]));
  }

  return remainingParams;
};

export default storeDeepLink;
